module.exports = __webpack_public_path__ + "img/sizpack-black.0d9611a5.svg";